export enum SignPasswordChangeType {
    NONE = "NONE",
    ENTER = "ENTER",
    SEND = "SEND",
    EXPIRED = "EXPIRED",
    COMPLETED = "COMPLETED",
    CHANGED = "CHANGED",
    ERROR = "ERROR"
}